const appProduct = {

    smoothScroll: () => {

        let links   = document.querySelectorAll('a');

        if ( links ) {
            [].forEach.call(links, (link) => {
                link.addEventListener('click', (e) => {

                    if ( !link.getAttribute('href').contains('#') ) {
                        return;
                    }

                    if ( link.getAttribute('href') == '#chat' ) {
                        window.tidioChatApi.show();
                        window.tidioChatApi.open();
                    } else {
                        let target = document.querySelector(link.getAttribute('href'));
                        if ( target ) { 
                            e.preventDefault();
                            target.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            }); 
                        }
                    }
                    
                });  
            });
        }

    },

    setSticky: () => {

        if ( window.innerWidth < 990 ) {
            return;
        }

        let wrapper         = document.querySelector('.product__info-wrapper');
        let stickyWrapper   = document.querySelector('.product__info-wrapper');
        let sticky          = document.querySelector('.product__info--sticky');

        if ( sticky.getBoundingClientRect().height == wrapper.getBoundingClientRect().height ) {
            return;
        }

        let sidebarWidth    = stickyWrapper.offsetWidth;
        let scrollStart     = wrapper.getBoundingClientRect().top;
        let scrollEnd       = wrapper.getBoundingClientRect().height - sticky.offsetHeight + wrapper.getBoundingClientRect().top + window.scrollY;

        if ( scrollStart < 0 && window.scrollY < scrollEnd ) {
            sticky.style.width = `${sidebarWidth}px`;
            sticky.style.position = `fixed`;
	      	sticky.style.top = `0px`;
	      	sticky.style.bottom = "initial";
        } else if ( scrollStart < 0 && window.scrollY > scrollEnd ) {
            sticky.style.width = `${sidebarWidth}px`;
            sticky.style.position = `absolute`;
            sticky.style.top = `auto`;
            sticky.style.bottom = "0px";
        } else {
            sticky.style.top =  "0px";
		    sticky.style.position = "relative";
		    sticky.style.bottom = "initial";
        }

    },

    sizesTable: () => {
        let popup       = document.querySelector('.product__sizes-table');
        let trigger     = document.querySelector('.sizes-trigger');

        if ( trigger && popup ) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                popup.classList.add('active');
                document.body.style.overflow = 'hidden';
            });

            let close = popup.querySelector('.product__sizes-table--close');

            if ( close ) {
                close.addEventListener('click', () => {
                    popup.classList.remove('active');
                    document.body.style.overflow = 'auto';
                });
            }
        }

    },

    personalization: () => {

        let links   = document.querySelectorAll('.product-personalization-button');

        if ( links ) {
            [].forEach.call(links, function(link){
                link.addEventListener('click', function(e){
                    e.preventDefault();

                    if ( link.getAttribute('data-product-id') ) {
                        console.log(link.getAttribute('data-product-id'));
                        localStorage.setItem('customizer_product', link.getAttribute('data-product-id'));
                        window.location.href = link.getAttribute('href');
                    }

                });
            });
        }

    },

    init: () => {
        appProduct.setSticky();
        appProduct.sizesTable();
        appProduct.smoothScroll();
        appProduct.personalization();
    },

    onScroll: () => {
		appProduct.setSticky();
	},

    onResize: () => {
        appProduct.setSticky();
    }

}

window.addEventListener('DOMContentLoaded', () => {
    appProduct.init();

    window.addEventListener("resize", appProduct.onResize);
	window.addEventListener("scroll", appProduct.onScroll);
    window.dispatchEvent(new Event("resize"));
	window.dispatchEvent(new Event("scroll"));

});